(function () {
  function show(el) {
    if (!el) return;
    el.style.display = 'block';
    el.style.opacity = '1';
  }

  function hide(el) {
    if (!el) return;
    el.style.display = 'none';
    el.style.opacity = '0';
  }

  function init() {
    var outer = document.querySelector('.pop-up-final-outer');
    var quizCon = document.querySelector('.pop-up-quiz-con');
    if (!outer || !quizCon) return;

    document.addEventListener('click', function (e) {
      var quizBtn = e.target.closest('.quiz-button');
      if (quizBtn) {
        show(outer);
        show(quizCon);
        return;
      }

      if (e.target.closest('.close-icon')) {
        hide(outer);
      }
    });

    document.addEventListener('mouseup', function (e) {
      if (!quizCon.contains(e.target) && e.target !== quizCon) {
        hide(outer);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
